module.exports = __webpack_public_path__ + "assets/edit-alt-90b199ff8575e5cd8d692ac52e25b56e.svg";